import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'squarebit_store_cookie_consent';

export const CookieConsent = () => {
  const { t } = useTranslation();
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setShow(false);
    window.location.reload();
  };

  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    // The strip spans the viewport but the card does not; only the card takes
    // clicks, or the strip blocks whatever sits beside it (the Standby reel's
    // speaker, for one) until the banner is dismissed.
    <div className="fixed bottom-0 left-0 right-0 z-100 p-[16px] md:p-[24px] pointer-events-none">
      <div className="pointer-events-auto max-w-[600px] mx-auto bg-surface-base rounded-[16px] border border-blue-100 shadow-[0_8px_30px_rgba(0,0,0,0.12)] p-[20px]">
        <p className="font-body text-[14px] text-content-secondary leading-relaxed mb-[16px]">
          {t('cookie.message')}{' '}
          <Link to="/privacy" className="text-blue-link font-semibold underline">
            {t('footer.privacy')}
          </Link>{' '}
          {t('cookie.forDetails')}
        </p>
        <div className="flex gap-[8px]">
          <button
            type="button"
            onClick={accept}
            className="h-[40px] px-[20px] rounded-[32px] bg-blue text-surface-base font-body text-[13px] font-medium hover:bg-blue-900 transition-all"
          >
            {t('cookie.accept')}
          </button>
          <button
            type="button"
            onClick={decline}
            className="h-[40px] px-[20px] rounded-[32px] border border-border-alt bg-surface-secondary-alt font-body text-[13px] font-medium text-base-black hover:bg-border-alt transition-all"
          >
            {t('cookie.decline')}
          </button>
        </div>
      </div>
    </div>
  );
};
